import { render, staticRenderFns } from "./ImportUpload.vue?vue&type=template&id=722f9558&"
import script from "./ImportUpload.vue?vue&type=script&lang=js&"
export * from "./ImportUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports